module.exports = __webpack_public_path__ + "img/record.31e11ed3.png";